import dayjs from 'dayjs';
import 'dayjs/locale/es';

dayjs.locale('es');

export default function formatDate(date, format = 'DD/MM/YYYY HH:mm') {
  if (!date || !format) return null;

  return dayjs(date).format(format);
}


export const formatDateMonthYear = (dateStr) => {
  if (dateStr === null || dateStr === undefined || dateStr === '') return ''
  const [year, month] = String(dateStr).split('-')
  if (!month) return year
  const parsedMonth = Number.parseInt(month, 10)
  if (Number.isNaN(parsedMonth) || parsedMonth < 1 || parsedMonth > 12) return year

  const parsedYear = Number.parseInt(year, 10)
  if (Number.isNaN(parsedYear)) return year
  const date = new Date(parsedYear, parsedMonth - 1)

  const mon = new Intl.DateTimeFormat('es', { month: 'short' }).format(date)
  return `${mon.charAt(0).toUpperCase() + mon.slice(1).replace('.', '')} ${year}`
}

export const formatTitleDate = (isoString) => {
  if (!isoString) return ''
  const date = new Date(isoString)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${day}/${month}/${year} ${hours}:${minutes}`
}
